function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import themeNames from "../themeNames";
import upgrade from "./upgrade";
export default _objectSpread(_objectSpread({}, upgrade), {}, {
  name: themeNames.UPGRADE_DARK_THEME_NAME,
  bodyColor: "#f0f1f5",
  bodyBg: "#0c0d12",
  headingsColor: "#f0f1f5",
  grayDarkest: "#37383a",
  grayDarker: "#646569",
  grayDark: "#8a8a8d",
  graySlightlyDark: "#a8a8aa",
  gray: "#bbbbbb",
  graySlightlyLight: "#dbd8d6",
  grayLight: "#e7e5e3",
  grayLighter: "#f5f4f3",
  grayLightest: "#fbfbfb",
  btnSecondaryBackground: "#0c0d12",
  // Neutral
  btnNeutralBackground: "#0c0d12",
  btnNeutralBorder: "2px solid #37383a",
  btnNeutralTextColor: "#e7e5e3",
  // Neutral Hover
  btnNeutralBackgroundHover: "#181a24",
  btnNeutralBorderHover: "2px solid #3f4042",
  btnNeutralTextColorHover: "#e7e5e3",
  // Neutral Active & Focus
  btnNeutralBackgroundActive: "#181a24",
  btnNeutralBorderActive: "2px solid #3f4042",
  btnNeutralTextColorActive: "#e7e5e3",
  textInputBorder: "1px solid #37383a",
  textInputBackgroundColor: "#0c0d12",
  textInputTextColor: "#f0f1f5",
  textInputErrorBorder: "1px solid #d46875",
  textInputErrorBackgroundColor: "#0c0d12",
  textInputDisabledTextColor: "#646569",
  textAreaBackground: "#0c0d12",
  textAreaBorder: "1px solid #37383a",
  textAreaBorderRadius: "2px",
  textAreaTextColor: "#f0f1f5",
  modalOverlayBackground: "rgba(13, 13, 13, 0.75)",
  modalBackground: "#0c0d12",
  modalBorder: "1px solid #37383a",
  // steps
  stepsBackground: "#37383a",
  stepsBackgroundComplete: "#2cb582",
  stepsTextColor: "#e7e5e3",
  // tables
  tableBorderBottom: "1px solid #2d3142",
  tableStripedBackground: "#222533",
  // surfaces
  surfaceBackgroundColor: "#181a24",
  surfaceTextColor: "##fff",
  surfaceBorderColor: "#232634",
  surfaceBorderRadius: "3px",
  surfaceBoxShadow: "none"
});
//# sourceMappingURL=dark.js.map